import React, { createContext, useContext, useState } from 'react';

const PackageContext = createContext(null);

export const PackageProvider = ({ children }) => {
  const [clientData, setClientData] = useState(() => {
    try {
      const saved = sessionStorage.getItem('tca_client_data');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });

  const updateClientData = (data) => {
    setClientData(data);
    try {
      sessionStorage.setItem('tca_client_data', JSON.stringify(data));
    } catch {
      // sessionStorage unavailable — proceed without persistence
    }
  };

  const clearClientData = () => {
    setClientData(null);
    try {
      sessionStorage.removeItem('tca_client_data');
    } catch {
      // ignore
    }
  };

  return (
    <PackageContext.Provider value={{ clientData, updateClientData, clearClientData }}>
      {children}
    </PackageContext.Provider>
  );
};

export const usePackage = () => {
  const context = useContext(PackageContext);
  if (!context) throw new Error('usePackage must be used within a PackageProvider');
  return context;
};
